import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import moment from 'moment'
import type { GeoPlace } from 'tripPlanner/types/common'
import type { TripItem } from 'tripPlanner/types/tripItem'
import { getItemPlace } from 'tripPlanner/utils'

function isLastItemOfDay(allDayItems: Array<TripItem> | undefined, currentDate: moment.Moment | undefined, fromItem: TripItem): boolean {
  if (!allDayItems || !currentDate) return false

  const dayItems = allDayItems.filter(item => item.startDate &&
    moment(item.startDate).format(ISO_DATE_FORMAT) === currentDate.format(ISO_DATE_FORMAT) &&
    item.type !== 'ACCOMMODATION',
  )
  const sortedDayItems = dayItems.sort((a, b) => (a.itineraryRankString || '').localeCompare(b.itineraryRankString || ''),
  )
  return sortedDayItems.length > 0 && sortedDayItems[sortedDayItems.length - 1].id === fromItem.id
}

export function findAccommodationForDay(allDayItems: Array<TripItem> | undefined, currentDate: moment.Moment | undefined): TripItem | undefined {
  if (!allDayItems || !currentDate) return undefined

  return allDayItems.find(item => item.type === 'ACCOMMODATION' &&
    item.startDate &&
    item.endDate &&
    moment(currentDate).isBetween(item.startDate, item.endDate, 'day', '[]'),
  )
}

export function getDestinationPlace(fromItem: TripItem, toItem: TripItem, allDayItems: Array<TripItem> | undefined, currentDate: moment.Moment | undefined): GeoPlace | undefined {
  const isLastItem = isLastItemOfDay(allDayItems, currentDate, fromItem)
  const accommodationForDay = findAccommodationForDay(allDayItems, currentDate)

  if (isLastItem && accommodationForDay) {
    const accommodationPlace = getItemPlace(accommodationForDay, 'start')
    return accommodationPlace?.type === 'GEO' ? accommodationPlace : undefined
  } else {
    const nextItemPlace = getItemPlace(toItem, 'start')
    return nextItemPlace?.type === 'GEO' ? nextItemPlace : undefined
  }
}

export const isFirstItemOfDay = (allDayItems: Array<TripItem> | undefined, currentDate: moment.Moment | undefined, fromItem: TripItem): boolean => {
  if (!allDayItems || !currentDate) return false

  const dayItems = allDayItems.filter(item => item.startDate &&
    moment(item.startDate).format(ISO_DATE_FORMAT) === currentDate.format(ISO_DATE_FORMAT) &&
    item.type !== 'ACCOMMODATION',
  )
  const sortedDayItems = dayItems.sort((a, b) => (a.itineraryRankString || '').localeCompare(b.itineraryRankString || ''))
  return sortedDayItems.length > 0 && sortedDayItems[0].id === fromItem.id
}
